import { Action, Selector, State, StateContext } from '@ngxs/store';

import {
  SetBreadcrumbs,
  SetHeaderMenuContext,
  ToggleHeader,
  ToggleSidebar,
} from './main-view.actions';

export interface IMainViewState {
  sidebarOpen: boolean;
  breadcrumbs: BreadcrumbItem[];
  headerHidden: boolean;
  headerMenuContext: HeaderMenuContext.Logged | HeaderMenuContext.NotLogged;
}

export interface BreadcrumbItem {
  url: string;
  title: string;
  active: boolean;
}

export enum HeaderMenuContext {
  Logged = 'logged',
  NotLogged = 'not_logged',
}

export type HeaderMenuContextType = HeaderMenuContext.Logged | HeaderMenuContext.NotLogged;

@State<IMainViewState>({
  name: 'mainView',
  defaults: {
    sidebarOpen: false,
    breadcrumbs: [],
    headerHidden: false,
    headerMenuContext: HeaderMenuContext.NotLogged,
  },
})
export class MainViewState {
  @Selector([MainViewState])
  public static isMainHeaderHidden(state: IMainViewState): boolean {
    return state.headerHidden && !state.sidebarOpen;
  }

  @Action(ToggleSidebar)
  private toggleSidebar(ctx: StateContext<IMainViewState>, action: ToggleSidebar): void {
    ctx.patchState({
      sidebarOpen: action.payload !== undefined ? action.payload : !ctx.getState().sidebarOpen,
    });
  }

  @Action(SetBreadcrumbs)
  private setBreadcrumbs(ctx: StateContext<IMainViewState>, action: SetBreadcrumbs): void {
    ctx.patchState({
      breadcrumbs: action.payload,
    });
  }

  @Action(ToggleHeader)
  private toggleHeader(ctx: StateContext<IMainViewState>, action: ToggleHeader): void {
    ctx.patchState({
      headerHidden: action.payload,
    });
  }

  @Action(SetHeaderMenuContext)
  private setHeaderMenuContext(
    ctx: StateContext<IMainViewState>,
    action: SetHeaderMenuContext,
  ): void {
    ctx.patchState({
      headerMenuContext: action.payload,
    });
  }
}
